'use strict';

/**
 * Object.keys polyfill wrapper
 *
 * @type {Object.keys|*|Function}
 */
module.exports = Object && Object.keys ? Object.keys : function (object) {
    var hasOwnProperty = Object.prototype.hasOwnProperty,
        keys = [],
        key;

    for (key in object) {
        if (hasOwnProperty.call(object, key)) {
            keys.push(key);
        }
    }

    return keys;
};
